import * as Yup from "yup";

import { labels, softwareApplications } from "./tagsValidationSchema";

const urlLengths = {
  min: 4,
  max: 512,
};

const titleLengths = {
  min: 3,
  max: 64,
};

const descriptionMaxLength = 256;

const url = (): Yup.StringSchema<string | undefined, object> =>
  Yup.string()
    .trim()
    .required("Url is required")
    .min(urlLengths.min, `Url must have at least ${urlLengths.min} characters`)
    .max(urlLengths.max, `Url cannot exceed ${urlLengths.max} characters`)
    .url("Invalid url");

const title = (): Yup.StringSchema<string | undefined, object> =>
  Yup.string()
    .trim()
    .required("Title is required")
    .min(titleLengths.min, `Title must have at least ${titleLengths.min} characters`)
    .max(titleLengths.max, `Title cannot exceed ${titleLengths.max} characters`);

const description = (): Yup.StringSchema<string | undefined, object> =>
  Yup.string().trim().max(descriptionMaxLength, `Description cannot exceed ${descriptionMaxLength} characters`);

export const linkInfo = Yup.object().shape({
  url: url(),
  title: title(),
  description: description(),
  labels,
  softwareApplications,
});
